<div class="product-backlog-container"
     [@productBacklog]="productBacklogIsOpen ? 'open' : 'closed'"
     [ngClass]="{
       'product-backlog-container--open' : productBacklogIsOpen,
       'product-backlog-container--closed': !productBacklogIsOpen
       }">
  <div class="product-backlog-title">{{'actionview.sprintplanning2.productbacklog' | translate}}</div>
  <div class="product-backlog-content">

    <div class="product-backlog-button" (click)="toggleProductBacklog()">
      <div class="product-backlog-label-wrapper">
        <span class="product-backlog-label">{{'actionview.sprintplanning2.productbacklog' | translate}}</span>
        <button mat-icon-button class="product-backlog-icon">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>

    <div id="product-backlog-issue-container" cdkDropList #backlogScrollContainer
         [cdkDropListData]="issues"
         [cdkDropListConnectedTo]="getConnectedIssues()"
         (cdkDropListDropped)="onIssueDrop($event)"
         (cdkDropListEntered)="onIssueDragListEnter($event)"
         (cdkDropListExited)="onIssueDragListEnterExit($event)"
    >
      <div class="pb-header-buttons">
        <button class="pb-button new-userstory-button" (click)="openNewIssueDialog($event)" mat-raised-button>
          + {{'actionview.sprintplanning2.addIssue' | translate}}
        </button>
        <button class="pb-button mark-all-read-button" (click)="markAllAsRead()" mat-raised-button>
          Mark all as read
        </button>
      </div>

      <template #newBacklogIssueComponent></template>

      <app-issue *ngFor="let issue of issues" cdkDrag
                 class="pb-issue teamwidgetdropzone imagedropzone whiteboarddropzone parent-issue-container"
                 id='pb-issue-container_{{issue.id}}'
                 [issue]="issue"
                 [projectKey]="projectKey"
                 [statuses]="statuses"
                 [inheritedIssueType]="issue.issueType"
                 [cdkDragData]="issue"
                 [attr.data-taskcardid]="issue.id"
                 [attr.data-highlightcolor]="issue.highlightColor"
                 [attr.data-issueid]="issue.id"
                 [attr.data-projectkey]="projectKey"
                 (issueRemoved)="onIssueRemoved($event)"
                 (cdkDragStarted)="onIssueMoveStarted($event)"
                 (cdkDragMoved)="onIssueMoved($event)"
      >

        <!-- Preview & Placeholder element -->
        <app-sp2-drag-preview [issue]="issue" [type]="'pb'" *cdkDragPreview></app-sp2-drag-preview>
        <div class="cdk-drag-placeholder-issue" *cdkDragPlaceholder></div>

      </app-issue>
    </div>

  </div>
</div>
